module.exports = __webpack_public_path__ + "static/media/GMC_logo_360x152.8e5ad71f.png";